import type { AudioTrackData, DirtyTrackChange } from "./types";

/**
 * Ключ несохранённой правки: `<язык>:<id>` — правка человека, `<язык>:<id>@<origin>` — сдвиг,
 * сделанный машиной (режим «Без автоправок», правило владельца 01.10.2026). У реплики может быть
 * обе, и они не сливаются: машинный сдвиг уходит отдельным помеченным запросом (заголовок
 * X-Edit-Origin), и журнал сервера пишет его машине, а не переводчику. Ключ правки человека —
 * прежний: по нему же отказы, несохранённый текст и «сбросить несохранённое».
 */
export const dirtyKeyOf = (change: Pick<DirtyTrackChange, "lang" | "trackId" | "origin">): string =>
    change.origin ? `${change.lang}:${change.trackId}@${change.origin}` : `${change.lang}:${change.trackId}`;

/** Поля, которыми правка ставит реплику на ленте: такая правка человека перекрывает сдвиг. */
const PLACE_FIELDS: (keyof AudioTrackData)[] = ["start", "start_rus_milli", "end_rus_milli", "length"];

export const movesPlace = (fields: Partial<AudioTrackData>): boolean =>
    PLACE_FIELDS.some((field) => fields[field] !== undefined);
